<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'ecard.template', params: { id: 0 } }" icon="icon-plus3">Ny template</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/ecard/templates'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="TemplateID" sort-order="asc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
                <template #cell_use_view="{ row }">
                    <div v-if="row.use_view" class="badge badge-success">Rednax™ builder</div>
                    <div v-else class="badge badge-primary">Legacy</div>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton.vue';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';

export default {
    name: 'EcardTemplateList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                header: '#',
                data: 'TemplateID',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'TemplateName',
                sortable: true,
            },
            {
                header: 'Kund',
                data: 'CompanyName',
                sortable: true,
            },
            {
                header: 'Typ',
                data: 'use_view',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/ecard/templates/' + row.TemplateID).focus();
            } else {
                this.$router.push({ name: 'ecard.template', params: { id: row.TemplateID } });
            }
        },
    },
};

</script>
